import { cn } from "@/lib/utils";

interface DashboardCardProps {
  children: React.ReactNode;
  className?: string;
  title?: string;
  subtitle?: string;
  onClick?: () => void;
}

export function DashboardCard({
  children,
  className,
  title,
  subtitle,
  onClick,
}: DashboardCardProps) {
  return (
    <div
      className={cn(
        "bg-black-950 flex cursor-pointer flex-col gap-2 rounded-lg p-5",
        className,
      )}
      onClick={onClick}
    >
      {title && (
        <h2 className="text-sm font-medium text-neutral-400">{title}</h2>
      )}
      {subtitle && <p className="text-xs text-neutral-500">{subtitle}</p>}
      {children}
    </div>
  );
}
